module.exports = __webpack_public_path__ + "img/marker_especific.8dcf9585.svg";